import { defineStore } from 'pinia'

interface AppState {
  systemInfo: UniApp.GetSystemInfoResult | null
  networkType: string
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    systemInfo: null,
    networkType: 'unknown',
  }),

  getters: {
    statusBarHeight: (state): number => state.systemInfo?.statusBarHeight ?? 0,
    safeAreaBottom: (state): number => {
      const safe = state.systemInfo?.safeAreaInsets
      return safe?.bottom ?? 0
    },
  },

  actions: {
    initSystemInfo(): void {
      try {
        this.systemInfo = uni.getSystemInfoSync()
      } catch (err) {
        console.error('[app:initSystemInfo]', err)
      }
    },

    setNetworkType(type: string): void {
      this.networkType = type
    },
  },
})
